export default __webpack_public_path__ + "static/media/assembly_ai_logo.56faf892.png";